import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LinkBaseConhecimento} from '../../../content/pages/models/link-base-conhecimento';

@Component({
  selector: 'rot-dialog-formulario-pesquisa',
  templateUrl: './dialog-formulario-pesquisa.component.html',
  styleUrls: ['./dialog-formulario-pesquisa.component.scss']
})
export class DialogFormularioPesquisaComponent implements OnInit {

  link: LinkBaseConhecimento;
  titulo: '';
  naoMostrarNovamente = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogFormularioPesquisaComponent>
  ) {
    this.link = data.infoLink;
    this.titulo = data.tituloFormulario;
  }

  ngOnInit() {
  }

  fechar() {
    this.dialogRef.close(this.naoMostrarNovamente);
  }

  redirecionarPara(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
